import React, { createContext, useState, useCallback } from 'react';
import Toast from '../Components/UI/Toast';

export const ToastContext = createContext(null);

let _emitToast = null;
export function addToast(message, type = 'info') {
  if (_emitToast) _emitToast(message, type);
}

const TOAST_TTL_MS = 7000;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToastLocal = useCallback((message, type = 'info') => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, TOAST_TTL_MS);
  }, []);

  _emitToast = addToastLocal;

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ addToast: addToastLocal, removeToast }}>
      {children}
      <div className="toastContainer" aria-live="polite">
        {toasts.map((t) => (
          <Toast
            key={t.id}
            message={t.message}
            type={t.type}
            onClose={() => removeToast(t.id)}
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
}
